'use strict';

angular.module('amexReconciliationApp')
  .directive('transactionActionButton', function (roles, actionStatusMappings, AdobeAnalyticsService) {
    var buttonContentForRole = {};

    var cardmemberButton = {
      needsAction: 'transactions.SubmitForApproval',
      undoAction: 'transactions.UndoSubmission',
      icon: 'fa-share'
    };
    buttonContentForRole[roles.CARDMEMBER] = cardmemberButton;
    buttonContentForRole[roles.LIMITED_CARDMEMBER] = cardmemberButton;

    var cardManagerButton = {
      needsAction: 'transactions.ApproveTransactionAsCardManager',
      undoAction: 'transactions.UnapproveTransactionAsCardManager',
      icon: 'fa-share'
    };
    buttonContentForRole[roles.CARD_MANAGER] = cardManagerButton;
    buttonContentForRole[roles.LIMITED_CARD_MANAGER] = cardManagerButton;

    var bcaManagerButton = {
      needsAction: 'transactions.ApproveTransactionAsBcaManager',
      undoAction: 'transactions.UnapproveTransactionAsBcaManager',
      icon: 'fa-share'
    };
    buttonContentForRole[roles.BCA_MANAGER] = bcaManagerButton;
    buttonContentForRole[roles.LIMITED_BCA_MANAGER] = bcaManagerButton;

    var accountingManagerButton = {
      needsAction: 'transactions.ApproveTransactionAsAccountingManager',
      undoAction: 'transactions.UnapproveTransactionAsAccountingManager',
      icon: 'fa-share'
    };
    buttonContentForRole[roles.ACCOUNTING_MANAGER] = accountingManagerButton;
    buttonContentForRole[roles.LIMITED_ACCOUNTING_MANAGER] = accountingManagerButton;

    return {
      restrict: 'E',
      templateUrl: 'scripts/views/directives/transaction-action-button.html',
      controllerAs: '$ctrl',
      controller: function (TransactionsStatusChangeService,
                            SelectedTransactionService,
                            ActiveTransactionModel,
                            LockStatusService,
                            AnalyticsService,
                            TransactionSearchModel,
                            SiteConfigModel) {
        var self = this;

        self.hasTakenAction = function hasTakenAction() {
          return TransactionsStatusChangeService.getStatus(
            transactions(),
            currentAction());
        };

        self.buttonText = function () {
          var actionToTake = self.hasTakenAction() ? 'undoAction' : 'needsAction';
          return currentButtonContent()[actionToTake];
        };

        self.buttonIconType = function buttonIconType() {
          return currentButtonContent().icon;
        };

        self.isDisabled = function () {

          if (transactions().length === 0) {
            return true;
          }

          if (transactions().length > 1) {
            if (!SiteConfigModel.massUpdateOn() ) {
              return true;
            }
          }

          if (isFullyLocked()) {
            return true;
          }

          if (isPartiallyLocked() && SiteConfigModel.siteConfig().partialLockOptions.approvalsLocked) {
            return true;
          }

          if (self.hasTakenAction() && !hasRoleThatCanRemoveApprovals()) {
            return true;
          }

          return false;

        };

        self.onClick = function () {
          var eventAsset = analyticsAsset(self.buttonText());
          AdobeAnalyticsService.eventTrack('click', { 'eventAsset': eventAsset, 'tab':'transactionTab'});

          if (currentRoleName() === roles.CARD_MANAGER ||
            currentRoleName() === roles.LIMITED_CARD_MANAGER) {
            AnalyticsService.trackCardManagerApproved();
          }
          TransactionsStatusChangeService.changeStatus(transactions());

        };

        self.shouldShowButton = function shouldShowButton() {
          return !_.isEmpty(currentAction());
        };

        function analyticsAsset(action){
            if(action === undefined)
              return ;
            if(action.indexOf('Unapprove')> -1)
              return 'Unapprove';
            else if(action.indexOf('Approve')> -1)
              return 'Approve';
            else if(action.indexOf('SubmitForApproval')> -1)
              return 'Submit';
            else if(action.indexOf('UndoSubmission') > -1)
              return 'Unsubmit';

        }
        function isFullyLocked() {
          if (ActiveTransactionModel.hasActiveTransaction()) {
            return LockStatusService.isLocked(ActiveTransactionModel.activeTransaction());
          } else {
            return SelectedTransactionService.anyFullyLockedSelected();
          }
        }

        function isPartiallyLocked() {
          if (ActiveTransactionModel.hasActiveTransaction()) {
            return LockStatusService.isPartiallyLocked(ActiveTransactionModel.activeTransaction());
          } else {
            return SelectedTransactionService.anyPartiallyLockedSelected();
          }
        }

        function currentRoleName() {
          return TransactionSearchModel.roleName();
        }

        function currentAction() {
          return actionStatusMappings[currentRoleName()];
        }

        function currentButtonContent() {
          return buttonContentForRole[currentRoleName()];
        }

        function transactions() {
          if (ActiveTransactionModel.hasActiveTransaction()) {
            return [ActiveTransactionModel.activeTransaction()];
          } else {
            return SelectedTransactionService.selectedTransactions();
          }
        }

        function hasRoleThatCanRemoveApprovals() {
          return SiteConfigModel.clearApprovalEnabledForRole(currentRoleName());
        }
      }
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/transactionActionButton.js
// module id = 536
// module chunks = 0